import { Col, Row } from 'antd';
import { useFormikContext } from 'formik';
import { CreateInsurerDetailsForm, InsuranceProductTypeForm, type InsurerFormValues, InsurerIntegration } from '.';
import { useGetModuleSpecsQuery } from '../../../../api/queries/getModuleSpecs';
import { type InsurerIntegrationProvider, type InsurerIntegrationSettings } from '../../../../api/types';

export type NewInsurerFormValues = InsurerFormValues & {
    integrationProvider: InsurerIntegrationProvider;
    integrationSettings: InsurerIntegrationSettings;
};

export const defaultIntegrationSettings: InsurerIntegrationSettings = {
    email: { email: '' },
    eazy: {
        username: '',
        password: '',
        apiUrl: '',
        sftpHost: '',
        sftpUser: '',
        privateKey: '',
        certCA: '',
    },
};

export const defaultValues: NewInsurerFormValues = {
    displayName: '',
    legalName: {
        defaultValue: '',
        overrides: [],
    },
    moduleId: null,
    email: '',
    order: null,
    sendEmailToCustomer: false,
    sendPDFToCustomer: false,
    submissionApprovalModuleId: null,
    reSubmissionApprovalModuleId: null,
    insuranceDisclaimer: {
        defaultValue: [{ defaultValue: '', overrides: [] }],
        overrides: [],
    },
    isActive: true,

    insuranceProductTypes: [],
    integrationProvider: null,
    integrationSettings: defaultIntegrationSettings,
};

const CreateInsurerFrom = () => {
    const { values } = useFormikContext<NewInsurerFormValues>();

    const { data: moduleData } = useGetModuleSpecsQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            moduleId: values?.moduleId,
        },
        skip: !values?.moduleId,
    });

    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <CreateInsurerDetailsForm module={moduleData?.module} />
            </Col>
            <Col span={24}>
                <InsuranceProductTypeForm isUpdate={false} />
            </Col>

            <Col span={24}>
                <InsurerIntegration provider={values.integrationProvider} />
            </Col>
        </Row>
    );
};

export default CreateInsurerFrom;
